// extracted by mini-css-extract-plugin
module.exports = {"header-container":"header_header-container__2vG99","header-text":"header_header-text__3mO7W"};